import React from 'react';
import './EnComptePopup.css';

export interface EnCompteItem {
  encompte_id: number;
  magasin_id: number;
  NomMagasin: string;
  solde: number | string;
  date: string;
}

interface EnComptePopupProps {
  show: boolean;
  magasins: EnCompteItem[];
  defaultMagasin: {
    id: number | string;
    NomMagasin: string;
    adresse_de_siege?: string;
  };
  onSelectSupplier: (item: EnCompteItem) => void;
  onSelectDefault: () => void;
  onClose: () => void;
}

export const EnComptePopup: React.FC<EnComptePopupProps> = ({
  show,
  magasins,
  defaultMagasin,
  onSelectSupplier,
  onSelectDefault,
  onClose,
}) => {
  if (!show) return null;

  return (
    <div className="ecp-overlay">
      <div className="ecp-modal">
        {/* Header */}
        <div className="ecp-header">
          <button className="ecp-close-btn" onClick={onClose} aria-label="Fermer">
            <i className="bi bi-x-lg" />
          </button>
          <div className="ecp-badge-header">
            <i className="bi bi-shield-check" />
            Mode En Compte
          </div>
          <h3 className="ecp-title">
            <i className="bi bi-shop-window" />
            Sélection du Magasin
          </h3>
          <p className="ecp-subtitle">
            Votre compte est configuré en mode <strong>En Compte</strong>. Choisissez un magasin fournisseur lié pour entrer avec son solde de crédit, ou continuez directement.
          </p>
        </div>

        {/* Body */}
        <div className="ecp-body">
          {/* Linked Supplier Magasins */}
          {magasins && magasins.length > 0 && (
            <>
              <span className="ecp-section-title">Magasins Fournisseurs Liés ({magasins.length})</span>
              {magasins.map((item) => (
                <button
                  key={item.encompte_id}
                  className="ecp-item"
                  onClick={() => onSelectSupplier(item)}
                >
                  <div className="ecp-item-left">
                    <div className="ecp-icon-box">
                      <i className="bi bi-building-check" />
                    </div>
                    <div className="ecp-item-info">
                      <h4 className="ecp-name">{item.NomMagasin}</h4>
                      <span className="ecp-meta">
                        <i className="bi bi-calendar3" style={{ marginRight: 4 }} />
                        Depuis le {item.date ? new Date(item.date).toLocaleDateString('fr-FR') : 'N/A'}
                      </span>
                    </div>
                  </div>

                  <div className="ecp-item-right">
                    <span className="ecp-solde-label">Solde Accordé</span>
                    <span className="ecp-solde-badge">
                      {parseFloat(String(item.solde || 0)).toLocaleString('fr-FR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}{' '}
                      MAD
                    </span>
                  </div>
                </button>
              ))}
            </>
          )}

          {/* Default Magasin Account Option */}
          <span className="ecp-section-title" style={{ marginTop: 8 }}>
            Ou continuer directement
          </span>
          <button
            className="ecp-item ecp-item-default"
            onClick={onSelectDefault}
          >
            <div className="ecp-item-left">
              <div className="ecp-icon-box ecp-icon-box-default">
                <i className="bi bi-person-badge" />
              </div>
              <div className="ecp-item-info">
                <h4 className="ecp-name">{defaultMagasin.NomMagasin}</h4>
                <span className="ecp-meta">Accéder à mon espace magasin standard</span>
              </div>
            </div>
            <i className="bi bi-arrow-right-circle-fill ecp-arrow" style={{ fontSize: 20 }} />
          </button>
        </div>

        {/* Footer */}
        <div className="ecp-footer">
          <button className="ecp-skip-btn" onClick={onSelectDefault}>
            Ignorer et continuer <i className="bi bi-arrow-right" style={{ marginLeft: 6 }} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default EnComptePopup;
